import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { Button, Alert } from '@resiliatech/birdsong'
import { NONPROFIT_ORG_PROFILE } from 'Apollo/Queries/NonprofitOrgProfile'
import { useAppState } from 'Context/AppContext/AppContext'
import { useRetriggerGoalsWizardMutation } from 'Generated/graphql-types'

export const GoalsWizard = () => {
  const {
    nonprofitOrgConfig: { orgId: nonprofitOrgId },
  } = useAppState()

  const [showAlert, setShowAlert] = useState(false)
  const [retriggerGoalsWizard] = useRetriggerGoalsWizardMutation({
    variables: {
      nonprofitOrgId,
    },
    refetchQueries: [NONPROFIT_ORG_PROFILE],
    onCompleted: () => {
      setShowAlert(true)
      setTimeout(() => setShowAlert(false), 10000)
    },
  })

  const handleRetriggerWizard = async () => {
    await retriggerGoalsWizard()
  }

  return (
    <Box
      sx={{ padding: '24px', maxWidth: '600px', backgroundColor: '#F0EEEB' }}
    >
      <Typography variant='h4' sx={{ mb: 3 }}>
        Goals Wizard
      </Typography>

      <Typography variant='body1' color='error' sx={{ mb: 4 }}>
        Warning: Using this flow will retrigger the goals wizard flow. Your
        previously confirmed organization summary and areas of impact will be
        deleted.
      </Typography>

      {showAlert && (
        <Alert
          severity='success'
          sx={{
            position: 'fixed',
            left: 24,
            bottom: 24,
            zIndex: 2000,
          }}
        >
          Goals wizard re-triggered successfully.
        </Alert>
      )}
      <Button
        variant='primary'
        label='Retrigger Goals Wizard'
        onClick={handleRetriggerWizard}
      />
    </Box>
  )
}
